import script from "./inFactoryRejectsListPage.vue?vue&type=script&setup=true&lang=js"
export * from "./inFactoryRejectsListPage.vue?vue&type=script&setup=true&lang=js"

import "./inFactoryRejectsListPage.vue?vue&type=style&index=0&id=eb5ab4e2&lang=scss"

const __exports__ = script;

export default __exports__